module.exports = __webpack_public_path__ + "img/lunas.0f2f380e.png";